// extracted by mini-css-extract-plugin
export var active = "v_bd";
export var activeTargetContainer = "v_b3";
export var container = "v_b";
export var content = "v_b8";
export var contentButton = "v_b9";
export var feature = "v_b6";
export var featureContainer = "v_b5";
export var featureText = "v_b7";
export var features = "v_b4";
export var footer = "v_cb";
export var footerText = "v_cc";
export var icon = "v_bq";
export var outerFeaturesContainer = "v_b2";
export var section = "v_d";
export var text = "v_b0";
export var title = "v_h";
export var topButton = "v_b1";
export var waveOne = "v_q";
export var waveThree = "v_bZ";
export var waveTwo = "v_n";
export var waves = "v_bY";